import React from 'react';
import { connect } from 'react-redux';
import { setDocumentForm } from '../../redux/actions/rootAction';
import withDocumentCommon from '../helpers/withDocumentCommon';
import { initWebSocket } from '../../redux/actions/websocket';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import PropTypes from 'prop-types';
import { downloadURI } from '../../lib/fileUtils';
import DocumentHelper from '../helpers/DocumentHelper';

export default function withPDFFormDocument(WrappedComponent) {
  // eslint-disable-next-line no-undef
  class withPDFFormDocumentWrapper extends React.Component {
    getPdfDownloadLink = async () => {
      let pdfUrl = '';
      await PaperflyAPI.getPdfDownloadLink(this.props.recipientRequestId, [
        this.props.document?.id
      ]).then(
        response => (pdfUrl = response.pdfUrl),
        error => console.log(error)
      );
      return pdfUrl;
    };

    /*doPrintDocument = async () => {
      const pdfUrl = await this.getPdfDownloadLink();
      if (pdfUrl) {
        printJS(pdfUrl);
      } else {
        printJS({
          maxWidth: 2000,
          documentTitle: ' ',
          printable: this.props.document.attachment,
          type: 'image',
          imageStyle: 'max-width: 99%;max-height: 99%;object-fit: contain;'
        });
      }
    };*/

    doDownloadDocument = async () => {
      const pdfUrl = await this.getPdfDownloadLink();
      if (pdfUrl) {
        downloadURI(pdfUrl, this.props.document.name + '.zip');
      } else {
        const docHelper = new DocumentHelper(
          this.props.document.attachment.map(attach => ({
            url: attach
          })),
          this.props.document.name
        );
        //docHelper.convertPagesToDataUrls(() => docHelper.download());
        docHelper.download();
      }
    };

    render() {
      return (
        <WrappedComponent
          doDownloadDocument={this.doDownloadDocument}
          {...this.props}
        />
      );
    }
  }

  withPDFFormDocumentWrapper.propTypes = {
    recipientRequestId: PropTypes.string,
    document: PropTypes.object
  };

  const mapStateToProps = (state, ownProps) => {
    const requestedDocument = ownProps.document || {
      id: 'fake_document',
      attachment: [''],
      attributes: {
        formStructure: [],
        pdfMetaData: [{}]
      }
    };

    return {
      isLandscape: state.isLandscape,
      actualScreenSize: state.actualScreenSize,
      formData: state.forms.get(requestedDocument.id) || new Map(),
      scrollContainer: ownProps.scrollContainer,
      autoSave: ownProps.autoSave,
      document: requestedDocument
    };
  };

  const mapDispatchToProps = dispatch => ({
    initWebsocket: () => dispatch(initWebSocket()),
    setDocumentForm: (documentId, form) =>
      dispatch(setDocumentForm(documentId, form))
  });

  return withDocumentCommon(
    connect(mapStateToProps, mapDispatchToProps)(withPDFFormDocumentWrapper)
  );
}
